module.exports = __webpack_public_path__ + "img/fault-do.3ee3997e.png";